/* eslint-disable no-nested-ternary */
import "./App.css";
import { Col, Container, Row, Spinner, Table } from "react-bootstrap";
import { useEffect, useState } from "react";
import { DocumentFullScreen } from "@chiragrupani/fullscreen-react";
import Carousel from "react-bootstrap/Carousel";
import * as payeurService from "./services/payeurService";
import consts from "./config/consts";

const App = () => {
	const [payeurs, setPayeurs] = useState([]);
	const [nbPages, setNbPages] = useState(1);
	const [isFirstLoad, setIsFirstLoad] = useState(true);
	const [isFullScreen, setIsFullScreen] = useState(false);
	const date = new Date();
	const year = date.getFullYear();
	const currentMonth = date.getMonth() + 1;

	const NB_PAYEURS_PAR_TABLEAU = 37;
	const NB_SECONDES_TABLEAU = 30;
	const NB_MINUTES_RAFRAICHISSEMENT = 10;

	useEffect(() => {
		const getPayeurs = async () => {
			const res = await payeurService.getPayeurs(year);
			if (res.status === consts.STATUS_SUCCESS) {
				setPayeurs(res.payeurs);
				setNbPages(Math.ceil(res.payeurs.length / (NB_PAYEURS_PAR_TABLEAU * 2)));
			} else {
				// eslint-disable-next-line no-undef
				window.location.reload();
			}
			setIsFirstLoad(false);
		};
		getPayeurs();
		setInterval(() => {
			getPayeurs();
		}, NB_MINUTES_RAFRAICHISSEMENT * 60 * 1000);
	}, [year]);

	return (
		<DocumentFullScreen
			isFullScreen={isFullScreen}
			onChange={(vIsFullScreen) => {
				setIsFullScreen(vIsFullScreen);
			}}
		>
			{isFullScreen ? null : (
				<button
					style={{ position: "absolute", top: "0px", right: "0px" }}
					type="button"
					onClick={() => setIsFullScreen(true)}
				>
					🖥️
				</button>
			)}
			<div style={{ paddingTop: "10px", paddingBottom: "5px" }}>
				<p style={{ fontSize: "30px", lineHeight: "10px", fontWeight: "bold" }}>
					CHARGES MOSQUEE {year}
				</p>
				<Container>
					<Row>
						<Col>
							<p style={{ fontSize: "18px", lineHeight: "25px", fontWeight: "bold" }}>
								TOUS LES FIDELES SONT PRIÉS DE PARTICIPER FINANCIÈREMENT POUR COUVRIR LES FRAIS DE
								LA MOSQUÉE. MERCI
							</p>
						</Col>
						<Col>
							<p style={{ fontSize: "25px", lineHeight: "30px", fontWeight: "bold" }}>
								الرجاء من جميع الصلين المشاركة ماديا لتغطية مصاريف المسجد. شكراً
							</p>
						</Col>
					</Row>
				</Container>
			</div>
			<div>
				{isFirstLoad ? (
					<div
						style={{
							alignItems: "center",
							height: "100vh",
							width: "100vw"
						}}
					>
						<Spinner style={{ marginTop: "36vh" }} animation="border" />
					</div>
				) : (
					<Carousel
						variant="dark"
						indicators={false}
						interval={NB_SECONDES_TABLEAU * 1000}
						pause={false}
						controls={false}
					>
						{[...Array(nbPages)].map((x, i) => {
							const payeursTab1 = payeurs.slice(
								(NB_PAYEURS_PAR_TABLEAU + NB_PAYEURS_PAR_TABLEAU) * i,
								(NB_PAYEURS_PAR_TABLEAU + NB_PAYEURS_PAR_TABLEAU) * i + NB_PAYEURS_PAR_TABLEAU
							);
							const payeursTab2 = payeurs.slice(
								NB_PAYEURS_PAR_TABLEAU + NB_PAYEURS_PAR_TABLEAU * 2 * i,
								NB_PAYEURS_PAR_TABLEAU + NB_PAYEURS_PAR_TABLEAU * 2 * i + NB_PAYEURS_PAR_TABLEAU
							);
							return (
								// eslint-disable-next-line react/no-array-index-key
								<Carousel.Item key={i}>
									<div
										style={{
											padding: "10px",
											paddingTop: "0px",
											display: "flex",
											flexDirection: "row"
										}}
									>
										<Table style={{ marginRight: "5px" }}>
											<thead>
												<tr>
													<th>N°</th>
													<th>Nom</th>
													<th>Jan.</th>
													<th>Fév.</th>
													<th>Mars</th>
													<th>Avr.</th>
													<th>Mai</th>
													<th>Juin</th>
													<th>Jui.</th>
													<th>Août</th>
													<th>Sep.</th>
													<th>Oct.</th>
													<th>Nov.</th>
													<th>Déc.</th>
												</tr>
											</thead>
											<tbody>
												{payeursTab1.map((payeur, index) => {
													let moisPaye;
													const tdArray = [];
													for (let m = 1; m <= 12; m++) {
														moisPaye =
															payeur.paiements.length > 0
																? payeur.paiements[
																		payeur.paiements.findIndex((paiement) => paiement.mois === m)
																  ]?.moisPaye === 1
																: false;

														let classNameTd = "";
														if (moisPaye) {
															classNameTd = "casePaye";
														} else if (!moisPaye && m < currentMonth) {
															classNameTd = "caseNonPaye";
														}
														tdArray.push(
															<td key={m} className={classNameTd}>
																{moisPaye ? "X" : ""}
															</td>
														);
													}
													return (
														<tr key={payeur.id}>
															<td>{NB_PAYEURS_PAR_TABLEAU * 2 * i + index + 1}</td>
															<td>{payeur.nom}</td>
															{tdArray}
														</tr>
													);
												})}
											</tbody>
										</Table>
										<Table
											style={{
												marginLeft: "5px",
												visibility: payeursTab2.length > 0 ? "visible" : "hidden"
											}}
										>
											<thead>
												<tr>
													<th>N°</th>
													<th>Nom</th>
													<th>Jan.</th>
													<th>Fév.</th>
													<th>Mars</th>
													<th>Avr.</th>
													<th>Mai</th>
													<th>Juin</th>
													<th>Jui.</th>
													<th>Août</th>
													<th>Sep.</th>
													<th>Oct.</th>
													<th>Nov.</th>
													<th>Déc.</th>
												</tr>
											</thead>
											<tbody>
												{payeursTab2.map((payeur, index) => {
													let moisPaye;
													const tdArray = [];
													for (let m = 1; m <= 12; m++) {
														moisPaye =
															payeur.paiements.length > 0
																? payeur.paiements[
																		payeur.paiements.findIndex((paiement) => paiement.mois === m)
																  ]?.moisPaye === 1
																: false;

														let classNameTd = "";
														if (moisPaye) {
															classNameTd = "casePaye";
														} else if (!moisPaye && m < currentMonth) {
															classNameTd = "caseNonPaye";
														}
														tdArray.push(
															<td key={m} className={classNameTd}>
																{moisPaye ? "X" : ""}
															</td>
														);
													}
													return (
														<tr key={payeur.id}>
															<td>
																{NB_PAYEURS_PAR_TABLEAU * 2 * i +
																	index +
																	1 +
																	NB_PAYEURS_PAR_TABLEAU}
															</td>
															<td>{payeur.nom}</td>
															{tdArray}
														</tr>
													);
												})}
											</tbody>
										</Table>
									</div>
								</Carousel.Item>
							);
						})}
					</Carousel>
				)}
			</div>
		</DocumentFullScreen>
	);
};

export default App;
